import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2e3cf6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listcard-wrapper" }
const _hoisted_2 = { class: "listcard-title" }
const _hoisted_3 = { class: "listcard-items" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "listcard-item-content" }
const _hoisted_6 = { class: "listcard-item-title" }
const _hoisted_7 = { class: "listcard-item-description" }
const _hoisted_8 = {
  key: 1,
  class: "listcard-item-content"
}
const _hoisted_9 = { class: "listcard-item-title" }
const _hoisted_10 = { class: "listcard-item-description" }


import CustomCard from "../generics/CustomCard.vue"; // anpassa path efter din struktur

interface ListItem {
	title: string;
	description: string;
	link: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCard',
  props: {
    title: null,
    items: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createBlock(CustomCard, { key: index }, {
          default: _withCtx(() => [
            (item.link)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.link,
                  class: "listcard-item-link"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1)
                  ])
                ], 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.description), 1)
                ]))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}
}

})